import { FilterUserType } from "@reactive-resume/dto";
import { create } from "zustand";

type FilterAdminState = {
  filterAdmin: FilterUserType | null | undefined;
  setFilterAdmin: (filter: FilterUserType) => void;
  replaceFilterAdmin: (filter: FilterUserType | null) => void;
  resetFilterAdmin: () => void;
};

export const userFilterAdminStore = create<FilterAdminState>((set) => ({
  filterAdmin: null,
  setFilterAdmin: (Nfilter) =>
    set((state) => ({
      filterAdmin: {
        ...(state.filterAdmin || {}),
        ...Nfilter,
      },
    })),

  replaceFilterAdmin: (Nfilter) =>
    set((state) => ({
      filterAdmin: {
        ...Nfilter,
      },
    })),

  resetFilterAdmin: () => set((state) => ({ filterAdmin: null })),
}));
